<template>
  <nav
    class="navbar navbar-expand-sm navbar-dark"
    style="background-color: #024da1"
  >
    <a class="navbar-brand" :href="$t('title.urlTuyenSinh')">
      <i class="fa fa-home"> </i>
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#collapsibleNavbar"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="collapsibleNavbar">
      <ul class="navbar-nav text-uppercase">
        <li class="nav-item">
          <router-link
            :to="{ name: 'dot-dang-ky' }"
            class="nav-link text-white"
          >
            {{ $t("menu.dangKy") }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'dieu-chinh-nguyen-vong' }"
            class="nav-link text-white"
          >
            {{ $t("menu.dieuChinh") }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'tra-cuu' }" class="nav-link text-white">
            {{ $t("menu.traCuu") }}
          </router-link>
        </li>
        <!-- <li class="nav-item">
          <router-link :to="{ name: 'nhap-hoc' }" class="nav-link text-white">
            {{ $t("menu.nhapHoc") }}
          </router-link>
        </li> -->
        <li class="nav-item">
          <router-link :to="{ name: 'lien-he' }" class="nav-link text-white">
            {{ $t("menu.lienHe") }}
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {};
</script>

<style scoped>
</style>